import React, {ChangeEvent, FC, SetStateAction, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {apiUrlWithStore} from "../../helper";
import {useRouter} from "next/router";
import {IState} from "../../types/state";
import {inputStateType} from "./types";
import cls from "./account.module.scss"
import {CustomSelect, CustomTextField} from "../../atoms";
import classNames from "classnames";
import shopApi from "../../api/shop";
import {TranslationsType} from "../../types/homePageTypes";

const AccountPageNewAddresses: FC<{ translationsData: TranslationsType }> = ({translationsData}) => {
    const form = useRef(null);
    const customer = useSelector((state: IState) => state.customer);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [address, setAddress] = useState<string>("");
    const [apartment, setApartment] = useState<string>("");
    const [success, setSuccess] = useState<boolean>(false);
    const [successData, setSuucessData] = useState<string | undefined>();
    const [input, setInput] = useState<inputStateType | Record<string, undefined>>({});
    const [code, setCode] = useState<{}>({})
    const history = useRouter();
    const [countryList, setCountryList] = useState<any>([])
    const [countryState, setCountryState] = useState<any>([])
    const [currentCountryCode, setCurrentCountryCode] = useState<any>(input.state)
    const [currentStateCode, setCurrentStateCode] = useState<any>(input.state)
    const countryEnum = {country: 'country', state: 'state'}

    useEffect(() => {
        let timer1: ReturnType<typeof setTimeout> = setTimeout(() => {
        });
        if (success || errors) {
            timer1 = setTimeout(() => {
                setErrors(false as unknown as SetStateAction<Record<string, string>>);
                setSuccess(false);
            }, 3000);
        }
        return () => {
            clearTimeout(timer1);
        };
    }, [errors, success]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                shopApi
                    .getCountryState()
                    .then((res) => setCountryState(res.data))
                shopApi
                    .getCountries()
                    .then((res) => setCountryList(res.data.reverse()))
            } catch (err: any) {
                throw new Error(err.message)
            }
        }
        fetchData()
    }, [])

    const handleChange = (e: { target: { value: string; name: string; }; }) => {
        countryList.forEach((element: { name: string; code: string | number; }) => {
            if (element.name === e.target.value) {
                let codeValue = {
                    value: element.code
                }
                setCode(codeValue)
            }
        });
        setInput({
            ...input as inputStateType,
            [e.target.name]: e.target.value,
        });
    };

    const handleChangeAdd = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setAddress(e.target.value)
    };

    const handleChangeApp = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setApartment(e.target.value)
    };

    const handleSubmit = (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        const trueState = countryState[currentCountryCode] ? input.state : "no state"
        let option = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                token: customer.token,
                first_name: input.first_name,
                last_name: input.last_name,
                address1: [address, apartment],
                city: input.city,
                country: input.country_name,
                country_name: input.country_name,
                phone: input.phone,
                postcode: input.postcode,
                state: trueState,
            }),
        };

        fetch(apiUrlWithStore(`/api/addresses/create`), option)
            .then((response) => response.json())
            .then((res) => {
                if (res.errors) {
                    setErrors(res.errors);
                } else {
                    setSuccess(true);
                    setSuucessData(res.message);
                    setInput({
                        first_name: "",
                        last_name: "",
                        address1: [],
                        apartment: "",
                        city: "",
                        country_name: "",
                        postcode: "",
                        phone: "",
                        state: "",
                    } as inputStateType);
                    setAddress("")
                    setApartment("")
                    history.push("/account/addresses");
                }
            });
    };

    useEffect(() => {
        fetch(apiUrlWithStore(`/api/countries?pagination=0`))
            .then((res) => res.json())
            .then((res) => setCountryList(res.data.reverse()));
    }, []);

    // const ErrorsOutput = () => {
    //     const arr = [];
    //     for (let error in errors) {
    //         arr.push(<div>{errors[error]}</div>);
    //     }
    //     return arr;
    // };

    /*TODO in this page need to refactor all the input and select fields like in checkout page!!!!!*/
    const combineChildValue = (name: any, code: any, key: any) => {
        if (key === countryEnum.country) {
            setCurrentCountryCode(code)
        } else if (key === countryEnum.state) {
            setCurrentStateCode(code)
            setInput(state => {
                return {
                    ...state,
                    state: name,
                }
            })
        }
    }

    const handleSelectChangeCountry = (event: ChangeEvent<HTMLSelectElement>) => {
        handleChange(event)
        filterCountryCode(event.target.value)
    }
    const handleSelectChangeState = (event: ChangeEvent<HTMLSelectElement>) => {
        handleChange(event)
        filterStateCode(event.target.value)
    }
    const filterCountryCode = (country = input.country_name) => {
        if (countryList.length > 0 && country) {
            for (let i = 0; i <= countryList.length; i++) {
                if (countryList?.[i]?.name == country) {
                    combineChildValue(country, countryList[i].code, countryEnum.country)
                }
            }
        }
    }

    const filterStateCode = (state = input.state) => {
        if (countryState[currentCountryCode] && currentCountryCode && state !== "no state") {
            countryState[currentCountryCode].forEach((element: any) => {
                if (element.default_name === state) {
                    combineChildValue(state, element.code, countryEnum.state)
                }
            })
        }
    }

    const classes = classNames(cls["country-container__list"],
        countryState.length > 0 && currentCountryCode && countryState[currentCountryCode] && cls.active_state
    )

    return (
        <>
            <div className={`${cls.card} ${cls["add-new-address-body"]}`}>
                <h3 className={cls["address-page-title"]}>
                    {translationsData.AddAnAddress}
                </h3>

                <form ref={form} onSubmit={handleSubmit}>
                    <div className={cls["card-body"]}>
                        <div className={cls["new-adresses"]}>
                            <div className={cls["form-row"]}>

                                <div className={cls["form-group"]}>
                                    <CustomTextField
                                        handleChange={handleChange}
                                        inpValue={input.first_name}
                                        name="first_name"
                                        value={translationsData.FirstName}
                                    />
                                    {
                                        errors && errors.first_name !== undefined &&
                                        <div className="alert-danger">
                                            {translationsData.TheFirstNameFieldIsRequired}
                                        </div>
                                    }
                                </div>

                                <div className={cls["form-group"]}>
                                    <CustomTextField
                                        handleChange={handleChange}
                                        inpValue={input.last_name}
                                        name="last_name"
                                        value={translationsData.LastName}
                                    />
                                    {
                                        errors && errors.last_name !== undefined &&
                                        <div className="alert-danger">
                                            {translationsData.TheLastNameFieldIsRequired}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className={`${cls["form-group"]} ${cls["new-adresses_address"]}`}>
                                <CustomTextField
                                    handleChange={handleChangeAdd}
                                    inpValue={address}
                                    name="address1"
                                    value={translationsData.Address}
                                />
                                {
                                    errors && errors.address1 !== undefined &&
                                    <div className="alert-danger">
                                        {translationsData.TheAddress1FieldIsRequired}
                                    </div>
                                }
                            </div>

                            <div className={cls["form-row"]}>
                                <div className={cls["form-group"]}>
                                    <CustomTextField
                                        handleChange={handleChangeApp}
                                        inpValue={apartment}
                                        name="address2"
                                        value={translationsData.Apartment}
                                    />
                                    {
                                        errors && errors.address2 !== undefined &&
                                        <div className="alert-danger">
                                            {translationsData.TheAddress2FieldIsRequired}
                                        </div>
                                    }
                                </div>
                                <div className={cls["form-group"]}>
                                    <CustomTextField
                                        handleChange={handleChange}
                                        inpValue={input.city}
                                        name="city"
                                        value={translationsData.City}
                                    />
                                    {
                                        errors && errors.city !== undefined &&
                                        <div className="alert-danger">
                                            {translationsData.TheCityFieldIsRequired}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className={cls["form-row"]}>
                                <>
                                    <div className={classes}>
                                        <CustomSelect
                                            translationsData={translationsData}
                                            defaultSelected={input.country_name}
                                            selectList={countryList}
                                            name="country_name"
                                            messageId="SelectCountry"
                                            printedFieldName="name"
                                            onChange={handleSelectChangeCountry}
                                        />
                                        {
                                            countryState[currentCountryCode] &&
                                            <CustomSelect
                                                translationsData={translationsData}
                                                defaultSelected={input.state}
                                                selectList={countryState[currentCountryCode]}
                                                name="state"
                                                messageId="SelectState"
                                                printedFieldName="default_name"
                                                onChange={handleSelectChangeState}
                                            />
                                        }
                                    </div>
                                </>
                            </div>

                            <div className={cls["form-row"]}>
                                <div className={cls["form-group"]}>
                                    <CustomTextField
                                        handleChange={handleChange}
                                        name="postcode"
                                        inpValue={input.postcode}
                                        type="number"
                                        value={translationsData.PostalCode}
                                    />
                                    {
                                        errors && errors.postcode !== undefined &&
                                        <div className="alert-danger">
                                            {translationsData.ThePostcodeFieldIsRequired}
                                        </div>
                                    }
                                </div>
                                <div className={cls["form-group"]}>
                                    <CustomTextField
                                        handleChange={handleChange}
                                        inpValue={input.phone}
                                        name="phone"
                                        type="number"
                                        value={translationsData.Phone}
                                    />
                                    {
                                        errors && errors.phone !== undefined &&
                                        <div className="alert-danger">
                                            {translationsData.ThePhoneFieldIsRequired}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className={cls["form-group"]}>
                                <button className="btn btn-primary btn-lg" type="submit">
                                    {translationsData.Save}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AccountPageNewAddresses;
